export enum AssignableType {
    ACCOUNT = 1,
    ROLE = 2,
    CONTACT = 3,
    MAIL = 4
}